/*
 * Copyright (c) 2020. Minerva Networks.
 * All rights reserved.
 */

const it = require('./locales/it.json');
const en = require('./locales/en.json');
const es = require('./locales/es.json');
const hu = require('./locales/hu.json');

const messages = {
  it,
  en,
  es,
  hu,
};

export default messages;
